import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Util from 'utility';

function Login() {
    const history = useHistory();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        Util.setPageTitle('Přihlášení');
    }, []);

    const doLogin = async (e) => {
        e.preventDefault();
        const newErrors = [];
        if (username === '') newErrors.push('username');
        if (password === '') newErrors.push('password');
        setErrors(newErrors);
        if (newErrors.length > 0) return;

        const result = await axios.get(
            Util.apiRoot() + '/login?username=' +
                encodeURIComponent(username) +
                '&password=' +
                encodeURIComponent(password)
        );
        if (typeof result.data !== 'undefined' && result.data.success === true) {
            localStorage.setItem('jwt_token', result.data.data.auth_token);
            history.push('/');
        } else {
            setErrors(['login_error']);
        }
    };

    require('styles/index.css');

    const inputClass = 'ml-auto w-4/5 px-3 py-[10px] rounded-sm bg-[#ffa] border border-[#bbb] shadow-[inset_1px_3px_4px_rgba(0,0,0,0.2)]';
    const inputErrorClass = 'ml-auto w-4/5 px-3 py-[10px] rounded-sm bg-[#ffa] border border-red-500 shadow-[inset_1px_3px_4px_rgba(0,0,0,0.2)]';

    return (
        <div className="w-full flex-1 flex items-center justify-center bg-[#efefef]">
            <div className="relative max-w-[480px] w-full bg-white px-[3em] py-[2em] mb-[5em] rounded-lg shadow-[0_16px_40px_rgba(0,0,0,0.13)]">
                <svg className="block w-[70%] h-auto mx-auto mb-[1.5em]" xmlns="http://www.w3.org/2000/svg" width="241" height="66.9" viewBox="0 0 63.8 17.7">
                    <g>
                        <path
                            d="M11.2 14.2H0v-1.8l7.2-9.6H.5V.2h10.7V2l-7 9.6h7zM18.3 14.4q-3 0-5-2-1.8-1.9-1.8-5 0-3.3 2-5.4 1.8-2 5-2 3 0 4.8 2 1.9 2 1.9 5.1 0 3.3-2 5.3-1.9 2-5 2zm.1-11.7q-1.7 0-2.6 1.2-1 1.3-1 3.3 0 2.1 1 3.3 1 1.2 2.5 1.2 1.6 0 2.6-1.2 1-1.1 1-3.2 0-2.2-1-3.4-.9-1.2-2.5-1.2zM34.6 2.8h-5v3.4h4.6v2.6h-4.5v5.4h-3.2V.2h8z"
                            fill="#333"
                        />
                        <path
                            d="M41.9 14.2v-2q-.5 1-1.4 1.6-1 .6-2 .6-1.5 0-2.3-.8-.8-.8-.8-2 0-2.6 3.4-3.1L42 8q0-3.2-2.4-3.2-1.7 0-3.2 1.3v-1q.5-.5 1.5-.8 1-.3 1.8-.3 1.5 0 2.3 1 .9.9.9 2.7v6.5zm-2.7-5q-1.6.2-2.2.8-.7.4-.7 1.6 0 .9.6 1.4.6.6 1.7.6 1.4 0 2.3-1 1-1.1 1-2.8v-1zM45.8 12.4v5.3h-1V4.2h1v2a4 4 0 011.5-1.6c.7-.4 1.4-.6 2.2-.6 1.3 0 2.3.4 3 1.3.7.9 1 2 1 3.5 0 1.7-.4 3-1.2 4-.8 1.1-1.9 1.6-3.2 1.6-1.5 0-2.6-.6-3.3-2zm0-3.7V10c0 1 .3 1.8.9 2.5.6.8 1.5 1.1 2.5 1.1a3 3 0 002.5-1.3c.6-.9 1-2 1-3.4 0-1.3-.4-2.3-1-3a2.8 2.8 0 00-2.3-1.1c-1.2 0-2 .4-2.7 1.2-.6.7-1 1.7-1 2.7zM56 12.4v5.3h-1V4.2h1v2a4 4 0 011.6-1.6c.6-.4 1.4-.6 2.2-.6 1.2 0 2.2.4 3 1.3.6.9 1 2 1 3.5 0 1.7-.4 3-1.2 4-.9 1.1-2 1.6-3.3 1.6-1.5 0-2.6-.6-3.3-2zm0-3.7V10c0 1 .3 1.8 1 2.5.6.8 1.4 1.1 2.4 1.1a3 3 0 002.5-1.3c.6-.9 1-2 1-3.4 0-1.3-.3-2.3-1-3a2.8 2.8 0 00-2.3-1.1c-1.1 0-2 .4-2.7 1.2-.6.7-1 1.7-1 2.7z"
                            fill="#4eb32d"
                        />
                    </g>
                </svg>
                {errors.includes('login_error') && <p className="text-center text-red-500">Neplatné přihlašovací údaje.</p>}
                <form onSubmit={doLogin}>
                    <div className="mt-[0.5em]">
                        <label className={`w-full flex items-center justify-center${errors.includes('username') ? ' text-red-500' : ''}`}>
                            <span>E-mail</span>
                            <input type="text" name="username" value={username} onChange={e => setUsername(e.target.value)} className={errors.includes('username') ? inputErrorClass : inputClass} />
                        </label>
                    </div>
                    <div className="mt-[0.5em]">
                        <label className={`w-full flex items-center justify-center${errors.includes('password') ? ' text-red-500' : ''}`}>
                            <span>Heslo</span>
                            <input type="password" name="password" value={password} onChange={e => setPassword(e.target.value)} className={errors.includes('password') ? inputErrorClass : inputClass} />
                        </label>
                    </div>
                    <div style={{ display: 'none' }}>
                        <label className="w-full flex items-center justify-center">
                            <span></span>
                            <input type="checkbox" name="remember" />
                            <em>&#x2713;</em> zapamatovat na tomto počítači
                        </label>
                    </div>
                    <div className="mt-[0.5em] pt-[0.5em]">
                        <label className="w-full flex items-center justify-center">
                            <button type="submit" className="bg-[#26AA52] text-white border-0 rounded-sm py-[0.7em] px-[2em] cursor-pointer hover:bg-[#2abb5a]">Přihlásit</button>
                        </label>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Login;
